









































































































































































































import Agent from '@/components/Agent.vue';
import Button from '@/atomics/Button.vue';
import Icon from '@/components/Icon.vue';
import Notification from '@/atomics/notifications/Notification.vue';
import QueueChunk from '@/components/QueueChunk.vue';
import Queue from '@/components/Queue.vue';
import SelectMultipleQueue from '@/components/select/multiple/queue/SelectMultipleQueue.vue';
import Select, { SelectOption } from '@/components/form/Select.vue';
import Toogle from '@/components/form/Toogle.vue';
import Tabs, { TabOption } from '@/components/Tabs.vue';
import Vision, { VisionMode } from '@/utils/vision';
import WebSocket from '@/socket';
import Veil from '@/atomics/Veil.vue';
import { Channel } from 'phoenix';
import {
    Component,
    Vue as VueBase,
    Inject,
    Prop,
    Provide,
    Watch,
} from 'vue-property-decorator';
import {
    Status,
    State,
    CustomStatus,
    AgentCustomStatus,
} from '@/utils/agent';
import createAgentChannel from '@/utils/agent/channel';
import createQueueChannel from '@/utils/queue/channel';
import idealName from '@/utils/ideal-name';
import createMaintenanceChannel from '@/utils/maintenance/channel';
import {
    AgentChannel, OfferAgent, Registration, Agent as AgentStore,
} from '@/store/modules/agent';
import { QueueMemberCall, QueueChannel, Queue as QueueStore } from '@/store/modules/queue';
import Logger from '@/utils/logger/logger';
import Spinner from '@/atomics/loaders/Spinner.vue';
import { UpdateLoadingAgent } from '@/store/modules/agent/events';
import { UpdateLoadingQueue } from '@/store/modules/queue/events';
import PanelCore from '@/core/Panel';
import PanelFilter from '@/components/PanelFilter.vue';
import ModalSettings from '@/components/panel/ModalSettings.vue';
import Tooltip from '@/components/Tooltip.vue';
import Filter from '@/core/panel/Filter';
import Setting from '@/core/panel/Setting';
import HttpClient from '@/api/http-client';
import UserInfo from '@/core/userinfo';
import StorageQueueVisibility from '@/core/queues/StorageVisibility';
import StorageQueueOrder from '@/core/queues/StorageOrder';
import InfoBox from '@/components/InfoBox.vue';
import { maxQueuesVisibleAllowed } from '@/store/modules/queue/getters';
import { toCamelCase } from '@/utils/text';
import PanelConfig from '@/components/panel/PanelConfig.vue';

enum TabFooterOption {
    Agents = 'agents',
    Queues = 'queues'
}

@Component({
    components: {
        Agent,
        Button,
        Icon,
        Notification,
        Queue,
        Select,
        Tabs,
        Toogle,
        QueueChunk,
        Spinner,
        PanelFilter,
        ModalSettings,
        Tooltip,
        Veil,
        SelectMultipleQueue,
        InfoBox,
        PanelConfig,
    },
})
export default class Panel extends VueBase {
    tabFooterOptions: Array<TabOption> = [];

    tabFooterActived = TabFooterOption.Agents;

    agents: Array<AgentStore> = [];

    selectedAgents: Array<AgentStore> = [];

    isFooterExpanded = false;

    isFooterMinimized = true;

    queues: Array<QueueStore> = [];

    registrations = new Map<string, Registration>();

    vision: Vision = Vision.new();

    visionMode: VisionMode = VisionMode.Maximized;

    wantedExtension = '';

    statusOptions: Array<SelectOption>= [];

    loadedTime = Date.now();

    maxQueuesVisibleAllowed = maxQueuesVisibleAllowed;

    storageQueueOrder !: StorageQueueOrder;

    protected showWaitingCallsWarning = false;

    protected queuesWithWaitingCalls = '';

    @Inject('logger') logger!: Logger;

    @Inject('httpClient') http!: HttpClient;

    panel: PanelCore = PanelCore.fromView(Filter.fromPanel(), Setting.fromPanel());

    @Prop(UserInfo) readonly userInfo!: UserInfo;

    @Prop(Object) readonly socket!: WebSocket;

    @Provide('storagePrefix') storagePrefix: string = toCamelCase(
        `${this.userInfo.username}-${this.userInfo.currentDomain}`,
    );

    private hasTriedAutoDomainChange = false;

    private wasDisconnected = false;

    private agentsChannel: Channel | null = null;

    private queuesChannel: Channel | null = null;

    private readonly joinTimeoutMs = 240000;

    private readonly softInitTimeoutMs = 12000;

    private joinedAgents = new Set<string>();

    private joinedQueues = new Set<string>();

    private requestedAgentInit = new Set<string>();

    private requestedQueueInit = new Set<string>();

    private agentInitTimers = new Map<string, number>();

    private queueInitTimers = new Map<string, number>();

    created() {
        this.$store.commit('setStorageVisibility', StorageQueueVisibility.create(this.storagePrefix));

        this.storageQueueOrder = StorageQueueOrder.create(this.storagePrefix);

        this.statusOptions = [
            {
                name: this.$t(`agent.custom_status.${CustomStatus.Available}`).toString(),
                value: CustomStatus.Available,
            },
            {
                name: this.$t(`agent.custom_status.${CustomStatus.Unavailable}`).toString(),
                value: CustomStatus.Unavailable,
            },
            {
                name: this.$t(`agent.custom_status.${CustomStatus.Busy}`).toString(),
                value: CustomStatus.Busy,
            },
            {
                name: this.$t('agent.custom_status.offline').toString(),
                value: CustomStatus.Offline,
            },
            { name: this.$t(`agent.status.${Status.NotAssign}`).toString(), value: '' },
        ];

        this.tabFooterOptions = [
            { name: this.$tc('agent.agent', 2), value: TabFooterOption.Agents, selected: true },
            { name: this.$tc('queue.queue', 2), value: TabFooterOption.Queues, selected: false },
        ];

        const maintenanceChannel = createMaintenanceChannel(this.socket);
        maintenanceChannel.join().receive('error', (response) => {
            this.logger.captureError(response);
            console.error('Unable to join on maintenance', response);
        });

        this.agentsChannel = this.socket.channel('agents:all');
        this.queuesChannel = this.socket.channel('queues:all');

        this.socket.onClose(() => {
            this.wasDisconnected = true;
        });

        this.socket.onOpen(() => {
            if (this.wasDisconnected) {
                const currentIndex = this.userInfo.customers.findIndex((c) => c.domain === this.userInfo.currentDomain);
                const indexToUse = currentIndex !== -1 ? currentIndex : 0;
                this.onChangeDomain(indexToUse);
            }
        });

        this.queuesChannel.on('all_queues', (data) => {
            this.initQueues(data.queues);

            data.queues.forEach((queue: QueueChannel) => {
                const updateLoadingQueue: UpdateLoadingQueue = { isLoading: false, name: queue.name };

                const channel = createQueueChannel(queue.name, this.socket, this.$store, () => {
                    this.$store.dispatch('isLoadingQueue', updateLoadingQueue);
                });

                this.$store.dispatch(
                    'addQueueToContainer',
                    {
                        name: queue.name,
                        tiers: [],
                        visible: this.$store.getters.storageVisibility.getQueueVisibility(queue.name),
                        membersCount: 0,
                        callsAnswered: 0,
                        agentOffers: new Map<string, OfferAgent>([]),
                        memberCalls: new Map<string, QueueMemberCall>([]),
                        metadata: { name: queue.metadata?.name },
                        isLoading: true,
                        channel,
                    },
                );
            });

            if (data.queues_init) {
                this.applyQueuesInit(data.queues_init);
            }

            this.syncQueueSubscriptions();
        });

        this.agentsChannel.on('all_agents', (data) => {
            this.agents = data.agents;
            this.registrations = new Map(Object.entries(data.registrations));
            this.selectedAgents = data.agents;

            data.agents.forEach((agent: AgentChannel) => {
                const updateLoadingAgent: UpdateLoadingAgent = { name: agent.name, isLoading: false };

                const channel = createAgentChannel(agent.name, this.socket, this.$store, () => {
                    this.$store.dispatch('isLoadingAgent', updateLoadingAgent);
                });

                this.$store.dispatch(
                    'addAgentToContainer',
                    {
                        name: agent.name,
                        tiers: [],
                        status: Status.None,
                        state: State.None,
                        callStates: new Map(),
                        queueCalls: new Map(),
                        isLoading: true,
                        metadata: { name: agent.metadata.name },
                        connected: this.registrations.has(agent.name),
                        lastActivityAtSecs: 0,
                        channel,
                        previousState: State.None,
                        doNotDisturb: false,
                    },
                );
            });

            if (data.agents_init) {
                this.applyAgentsInit(data.agents_init);
            }

            this.syncAgentSubscriptions();
        });

        this.queuesChannel.on('queues_stats', (data) => {
            const updatedQueueStats = { queueStats: data.queue_stats };
            this.$store.dispatch('updateQueueStats', updatedQueueStats);
            this.$root.$emit('queue_stats', data.queue_stats);
        });

        this.agentsChannel.on('update_registrations', (data) => {
            this.registrations = new Map<string, Registration>(Object.entries(data.registrations));
        });

        this.agentsChannel.join(this.joinTimeoutMs).receive('error', (response) => {
            this.logger.captureError(response);
            console.error('Unable to join on agents:all', response);
            this.tryAutoChangeDomain();
        });

        this.queuesChannel.join(this.joinTimeoutMs).receive('error', (response) => {
            this.logger.captureError(response);
            console.error('Unable to join on queues:all', response);
            this.tryAutoChangeDomain();
        });

        this.$root.$on('changeDomain', (index: number) => {
            this.onChangeDomain(index);
        });
    }

    minimizeFooter() {
        this.isFooterMinimized = !this.isFooterMinimized;
        this.isFooterExpanded = !this.isFooterExpanded;
        this.syncAgentSubscriptions();
    }

    onChangeOptions(selected: Array<string>) {
        if (selected.length === 0) {
            this.selectedAgents = this.agents;
        } else {
            this.selectedAgents = this.agents.filter((agent) => {
                const agentStore = this.$store.getters.getAgentByName(agent.name);
                const customStatus = AgentCustomStatus.fromAgent(
                    agentStore.status,
                    agentStore.state,
                    agentStore.previousState,
                );
                return (selected.includes(customStatus.status()) && agentStore.connected)
                        || (selected.includes(CustomStatus.Offline) && !agentStore.connected)
                        || (selected.includes('') && agentStore.status === '');
            });
        }
        this.syncAgentSubscriptions();
    }

    onChangeFooterOption(option: TabFooterOption) {
        this.tabFooterActived = option;
        this.syncAgentSubscriptions();
    }

    isTabFooterAgents() {
        return this.tabFooterActived === TabFooterOption.Agents;
    }

    isTabFooterQueues() {
        return this.tabFooterActived === TabFooterOption.Queues;
    }

    onToogleIdleTime(): void {
        if (this.panel.setting.idleTimeHidden) {
            this.$store.dispatch('refreshConnectedAgentsLastActivity');
        }
        this.panel.setting.toogleIdleTime();
    }

    onToogleAdvancedStats(): void {
        this.panel.setting.toogleAdvancedStats();
        this.panel = PanelCore.fromView(
            this.panel.filter,
            new Setting({
                idleTimeHidden: this.panel.setting.idleTimeHidden,
                advancedStats: this.panel.setting.advancedStats,
            }),
        );
    }

    onChangeDomain(index: number): void {
        const { domain } = this.userInfo.customers[index];

        this.http
            .patch('/user_domain', { user: { domain } })
            .then(() => window.location.reload())
            .catch((err) => console.error('Cambio de dominio falló:', err));
    }

    changeQueuesOrder(queuesOrder: QueueStore[]) {
        this.queues = [...queuesOrder];

        this.storageQueueOrder.saveCustomOrder(this.queues);
    }

    changeVision(visionToChange: string): void {
        const vision = this.vision as any;

        this.visionMode = vision[visionToChange]();
    }

    toggleSettingsModal(): void {
        const modal = this.$refs.modalSettings as any;

        modal.toogle();
    }

    get footerMinimizedIcon() {
        return this.isFooterMinimized ? 'arrows-expand' : 'minus';
    }

    get filteredAgents() {
        const text = this.wantedExtension.toLowerCase();
        return this.selectedAgents
            .filter((agent): boolean => agent.metadata?.name?.toLowerCase().startsWith(text)
                                   || agent.name.startsWith(text))
            .sort(this.sortAgent);
    }

    get visibleQueues() {
        return this.$store.getters.getVisibleQueues();
    }

    @Watch('filteredAgents', { deep: true })
    onFilteredAgentsChanged() {
        this.syncAgentSubscriptions();
    }

    @Watch('visibleQueues', { deep: true })
    onVisibleQueuesChanged() {
        this.syncQueueSubscriptions();
    }

    protected get userHasWaitingCallsFunctionality() {
        return this.userInfo.username === 'PWRJORGE'
        || this.userInfo.username === 'ABALUARTE3'
        || this.userInfo.username === 'VQUIJANO1'
        || this.userInfo.username === 'JUANGONZALEZ'
        || this.userInfo.username === 'JOVATESTPCX';
    }

    private sortAgent(a: AgentStore, b: AgentStore) {
        if (this.$store.getters.agentExtensionName(a.name) < this.$store.getters.agentExtensionName(b.name)) {
            return -1;
        }
        return 1;
    }

    private initQueues(queues: QueueStore[]) {
        const queuesWithCustomOrder = this.storageQueueOrder.getCustomOrder();

        this.queues = [...queuesWithCustomOrder];

        const queuesNotInStorage = queues.filter((queue) => queuesWithCustomOrder.find(
            (queueWithCustomOrder) => queueWithCustomOrder.name === queue.name,
        ) === undefined);

        queuesNotInStorage.forEach((queue) => {
            this.queues.push(queue);
        });
    }

    private syncQueueSubscriptions(): void {
        if (!this.queuesChannel) return;

        const queueNames = (this.visibleQueues || []).map((queue: QueueStore) => queue.name);
        if (!queueNames.length) return;

        this.requestQueuesInit(queueNames);
        this.joinQueueChannels(queueNames);
    }

    private syncAgentSubscriptions(): void {
        if (!this.agentsChannel) return;

        const agentNames = new Set<string>();

        if (!this.isFooterMinimized && this.isTabFooterAgents()) {
            this.filteredAgents.forEach((agent: AgentStore) => agentNames.add(agent.name));
        }

        (this.visibleQueues || []).forEach((queue: QueueStore) => {
            const tiers = this.$store.getters.queueTiers(queue.name) || [];
            tiers.forEach((tier: { agent: string }) => {
                if (tier.agent) agentNames.add(tier.agent);
            });
        });

        const names = Array.from(agentNames);
        if (!names.length) return;

        this.requestAgentsInit(names);
        this.joinAgentChannels(names);
    }

    private requestQueuesInit(queueNames: string[]): void {
        if (!this.queuesChannel) return;
        if (typeof this.queuesChannel.push !== 'function') return;

        const toRequest = queueNames.filter((name) => !this.requestedQueueInit.has(name));
        if (!toRequest.length) return;

        toRequest.forEach((name) => {
            this.requestedQueueInit.add(name);
            this.startQueueInitTimer(name);
        });

        const pushRef = this.queuesChannel.push('init_queues', { queues: toRequest });
        if (!pushRef || !pushRef.receive) return;

        pushRef.receive('ok', (response) => {
            const payload = response || {};
            this.applyQueuesInit(payload.queues_init || []);
        });
        pushRef.receive('error', (response) => {
            console.warn('init_queues error', response);
        });
        pushRef.receive('timeout', () => {
            console.warn('init_queues timeout');
        });
    }

    private requestAgentsInit(agentNames: string[]): void {
        if (!this.agentsChannel) return;
        if (typeof this.agentsChannel.push !== 'function') return;

        const toRequest = agentNames.filter((name) => !this.requestedAgentInit.has(name));
        if (!toRequest.length) return;

        toRequest.forEach((name) => {
            this.requestedAgentInit.add(name);
            this.startAgentInitTimer(name);
        });

        const pushRef = this.agentsChannel.push('init_agents', { agents: toRequest });
        if (!pushRef || !pushRef.receive) return;

        pushRef.receive('ok', (response) => {
            const payload = response || {};
            this.applyAgentsInit(payload.agents_init || []);
        });
        pushRef.receive('error', (response) => {
            console.warn('init_agents error', response);
        });
        pushRef.receive('timeout', () => {
            console.warn('init_agents timeout');
        });
    }

    private joinQueueChannels(queueNames: string[]): void {
        queueNames.forEach((name) => {
            if (this.joinedQueues.has(name)) return;

            const queue = this.$store.getters.getQueueByName(name);
            if (!queue || !queue.channel || typeof queue.channel.join !== 'function') return;

            this.joinedQueues.add(name);
            this.startQueueInitTimer(name);

            queue.channel
                .join(this.joinTimeoutMs)
                .receive('error', (err: Error) => {
                    this.logger.captureError(err);
                    this.$store.dispatch('isLoadingQueue', { isLoading: false, name });
                    this.clearQueueInitTimer(name);
                })
                .receive('timeout', () => {
                    this.$store.dispatch('isLoadingQueue', { isLoading: false, name });
                    this.clearQueueInitTimer(name);
                });
        });
    }

    private joinAgentChannels(agentNames: string[]): void {
        agentNames.forEach((name) => {
            if (this.joinedAgents.has(name)) return;

            const agent = this.$store.getters.getAgentByName(name);
            if (!agent || !agent.channel || typeof agent.channel.join !== 'function') return;

            this.joinedAgents.add(name);
            this.startAgentInitTimer(name);

            agent.channel
                .join(this.joinTimeoutMs)
                .receive('error', (err: Error) => {
                    this.$store.dispatch('isLoadingAgent', { name, isLoading: false });
                    this.logger.captureError(err);
                    this.clearAgentInitTimer(name);
                })
                .receive('timeout', () => {
                    this.$store.dispatch('isLoadingAgent', { name, isLoading: false });
                    this.clearAgentInitTimer(name);
                });
        });
    }

    private applyQueuesInit(queuesInit: Array<any>): void {
        if (!Array.isArray(queuesInit)) return;

        const agentsFromQueues = new Set<string>();

        queuesInit.forEach((queueInit) => {
            const name = queueInit.queue || queueInit.name;
            if (!name) return;

            this.$store.dispatch('updateQueueTiers', { tiers: queueInit.tiers || [], name });
            this.$store.dispatch('updateQueueCallsAnswered', { callsAnswered: queueInit.calls_answered || 0, name });
            this.$store.dispatch('updateQueueMembersCount', { membersCount: queueInit.members_count || 0, name });
            this.$store.dispatch('updateQueueAgentOffers', { agentOffers: queueInit.agent_offers || {}, name });
            this.$store.dispatch('updateQueueMemberCalls', { memberCalls: queueInit.member_calls || {}, name });

            (queueInit.tiers || []).forEach((tier: { agent: string }) => {
                if (tier.agent) agentsFromQueues.add(tier.agent);
            });

            this.$store.dispatch('isLoadingQueue', { isLoading: false, name });
            this.clearQueueInitTimer(name);
        });

        if (agentsFromQueues.size) {
            const names = Array.from(agentsFromQueues);
            this.requestAgentsInit(names);
            this.joinAgentChannels(names);
        }
    }

    private applyAgentsInit(agentsInit: Array<any>): void {
        if (!Array.isArray(agentsInit)) return;

        agentsInit.forEach((agentInit) => {
            const name = agentInit.name || agentInit.agent;
            if (!name) return;

            if (agentInit.tiers) {
                this.$store.dispatch('updateTiers', { tiers: agentInit.tiers, name });
            }

            if (agentInit.queue_calls) {
                this.$store.dispatch('updateQueueCalls', { queueCalls: agentInit.queue_calls, name });
            }

            if (agentInit.call_states) {
                this.$store.dispatch('updateCallStates', { callStates: agentInit.call_states, name });
            }

            if (agentInit.last_activity_at_secs !== undefined) {
                this.$store.dispatch('updateLastActivityAtSecs', {
                    lastActivityAtSecs: agentInit.last_activity_at_secs,
                    name,
                });
            }

            if (agentInit.agent_state) {
                this.$store.dispatch('changeAgentState', { agentState: agentInit.agent_state, name });
            }

            if (agentInit.agent_status) {
                this.$store.dispatch('changeAgentStatus', { agentStatus: agentInit.agent_status, name });
            }

            if (agentInit.do_not_disturb) {
                this.$store.dispatch('putAgentInDoNotDisturb', {
                    state: agentInit.do_not_disturb.state,
                    status: agentInit.do_not_disturb.status,
                    name,
                });
            }

            this.$store.dispatch('isLoadingAgent', { name, isLoading: false });
            this.clearAgentInitTimer(name);
        });
    }

    private startAgentInitTimer(name: string): void {
        if (this.agentInitTimers.has(name)) return;

        const timer = window.setTimeout(() => {
            const agent = this.$store.getters.getAgentByName(name);
            if (agent && agent.isLoading) {
                console.warn(`Agent init timeout: ${name}`);
                this.$store.dispatch('isLoadingAgent', { name, isLoading: false });
            }
            this.agentInitTimers.delete(name);
        }, this.softInitTimeoutMs);

        this.agentInitTimers.set(name, timer);
    }

    private clearAgentInitTimer(name: string): void {
        const timer = this.agentInitTimers.get(name);
        if (timer) {
            clearTimeout(timer);
            this.agentInitTimers.delete(name);
        }
    }

    private startQueueInitTimer(name: string): void {
        if (this.queueInitTimers.has(name)) return;

        const timer = window.setTimeout(() => {
            const queue = this.$store.getters.getQueueByName(name);
            if (queue && queue.isLoading) {
                console.warn(`Queue init timeout: ${name}`);
                this.$store.dispatch('isLoadingQueue', { isLoading: false, name });
            }
            this.queueInitTimers.delete(name);
        }, this.softInitTimeoutMs);

        this.queueInitTimers.set(name, timer);
    }

    private clearQueueInitTimer(name: string): void {
        const timer = this.queueInitTimers.get(name);
        if (timer) {
            clearTimeout(timer);
            this.queueInitTimers.delete(name);
        }
    }

    protected checkIfShowWaitingCallsWarning(): void {
        const showNotifications = window.localStorage.getItem('showNotifications');

        if (showNotifications === 'false') {
            return;
        }

        let showNotification = false;

        this.showWaitingCallsWarning = false;

        this.queuesWithWaitingCalls = '';

        const minNumberOfWaitingCallsToShowWarning = 1;
        const queuesNames: string[] = [];

        this.queues.forEach((element) => {
            const membersCount = this.$store.getters.queueMembersCount(element.name);

            if (membersCount >= minNumberOfWaitingCallsToShowWarning) {
                queuesNames.push(idealName(element.name));

                showNotification = true;
            }
        });

        if (showNotification) {
            this.showNotification();
        }

        this.queuesWithWaitingCalls = queuesNames.join(', ');
    }

    protected async showNotification() {
        this.showWaitingCallsWarning = true;

        await new Promise((resolve) => setTimeout(resolve, 6000));

        this.showWaitingCallsWarning = false;
    }

    protected hideNotification(): void {
        this.showWaitingCallsWarning = false;
    }

    /**
     * Intenta cambiar el dominio automáticamente al primero disponible si ocurre un error en el join de canales.
     * Solo lo intenta una vez para evitar loops infinitos.
     */
    private tryAutoChangeDomain() {
        if (this.hasTriedAutoDomainChange) return;
        this.hasTriedAutoDomainChange = true;
        if (this.userInfo && Array.isArray(this.userInfo.customers) && this.userInfo.customers.length > 0) {
            const { currentDomain, customers } = this.userInfo;
            const firstAvailableIndex = customers.findIndex((c) => c.domain !== currentDomain);
            const indexToUse = firstAvailableIndex !== -1 ? firstAvailableIndex : 0;
            this.onChangeDomain(indexToUse);
        }
    }
}
